import { ref } from 'vue';

export const eventBus = ref({
  showSimulation: true,
});

console.log('redirection.ts')
